module.exports = __webpack_public_path__ + "img/4.b79ab2dd.jpg";